import {
  Flex,
  Icon,
  Notification,
  NotificationProps,
  PrimaryButton,
  Typo,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  CustomerAccount,
  hasMissingPaymentMethod,
  PaymentMethod,
  PaymentMethodType,
} from '../../../domain'
import { useSetupStripe } from '../../../hooks/stripe'
import { TKey, useWriskTranslation } from '../../../infrastructure/internationalisation'

export interface CardMissingNotificationProps extends NotificationProps {
  paymentMethods: PaymentMethod[]
  customerAccounts: CustomerAccount[]
}

const tKey = TKey('components.card-missing-notification')

const Content: FunctionComponent<NotificationProps> = (props) => {
  const { t } = useWriskTranslation()

  const onSetupStripe = useSetupStripe({
    successPath: location.pathname,
    cancelPath: location.pathname,
  })

  return (
    <Notification
      type='standalone'
      variant='critical'
      flexDirection={['column', 'column', 'row']}
      {...props}
    >
      <Flex mr={[0, 0, 4]} mb={[4, 4, 0]}>
        <Icon icon='warning' display={['none', 'none', 'block']} mr={4} />
        <Typo>{t(tKey('header'))}</Typo>
      </Flex>
      <PrimaryButton
        variant='critical'
        onClick={onSetupStripe.execute}
        loading={onSetupStripe.loading}
        layout={['default', 'default', 'fixed']}
        width={1}
        whiteSpace='nowrap'
      >
        {t(tKey('actions.set-up'))}
      </PrimaryButton>
    </Notification>
  )
}

export const CardMissingNotification: FunctionComponent<CardMissingNotificationProps> = ({
  paymentMethods,
  customerAccounts,
  ...props
}) => {
  const paymentMethod = hasMissingPaymentMethod(
    customerAccounts,
    paymentMethods,
    PaymentMethodType.CARD,
  )
  return paymentMethod ? <Content {...props} /> : null
}
